import { render, staticRenderFns } from "./CostCenter.vue?vue&type=template&id=72f9962a&scoped=true"
import script from "./CostCenter.vue?vue&type=script&lang=js"
export * from "./CostCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9962a",
  null
  
)

export default component.exports